import React from "react";
import { hideplayIcon, share } from "../../utils/Helper";

const ReelCard = ({
  reel,
  handleclick,
  isShort,
  isEpisode,
  isShortReel,
  handleShareData,
  index,
  shortsData,
  indexforslide,
  type,
  shareText,
}) => {
  // const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <div className="reel_card_pad">
        <div className="reel_card_bg">
          <div className="reel_card">
            <button
              className="reelshare_btn"
              onClick={() => {
                const shareUrl =
                  isEpisode || isShortReel
                    ? `https://www.narendramodi.in/parikshapecharcha2025/${reel.episode_id}/shorts/${reel.id}`
                    : isShort
                    ? `https://www.narendramodi.in/parikshapecharcha2025/shorts/${reel.id}`
                    : `https://www.narendramodi.in/parikshapecharcha2025/reel/${reel.id}`;

                share(reel.id, shareText, "youtube", shareUrl);
                handleShareData(shareUrl, shareText, shareText, "youtube");
              }}
            >
              <img src="/assets/images/sharereel.svg" alt="" />
            </button>
            <img src={reel.image_url} className="reel_thumb" alt="" />

            <button
              className="reel_play_btn play_layer  "
              style={{ zIndex: 99 }}
              onClick={() =>
                handleclick(index, shortsData, indexforslide, type)
              }
              onMouseMove={() => {
                hideplayIcon(reel.id);
              }}
            >
              <img
                src="/assets/images/playvideoppc.svg"
                alt=""
                className={"play_icon playpausebtn_" + reel.id}
              />
            </button>

            <div className="reelslider_overlay2"></div>
            <div className="reel_content">
              <p>{reel.title}</p>
              <h4>{reel.description}</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ReelCard;
